module.exports = __webpack_public_path__ + "static/media/file-redo-alt.d4ff6f1a.svg";